module.exports = __webpack_public_path__ + "static/media/icon_206.7b5d4190.svg";